export class Poll {
    $key: string;
    title: string;
    answersCount: number = 0;
    eventId: string;
    type: string;
    createdBy: string;
    // isMultipleAnswersAllowed: boolean = false;
    // isReasonAvailable: boolean = false;
    // isReasonMandatory: boolean = false;
    questions = new Array<string>();
    sessionId: string;
    pollReleaseType: string = 'IMMEDIATELY';
    // options = new Array<string>();
    counters = new Array<number>(null);
    totalAnswer: number = 0;
    position: number;
    isReleased: boolean = true;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/poll-new.ts